<template>
  <v-card class="card-border mt-4">
    <v-row class="pl-4 pr-4">
      <v-col cols="12" md="4" lg="4">
        <v-autocomplete
          v-model="company"
          label="Público Alvo"
          item-text="nome"
          item-value="cnpj"
          :items="selectEmpresa"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" lg="4">
        <v-text-field
          v-model="message.title"
          label="Titulo">
        </v-text-field>
      </v-col>
      <v-col cols="12" md="12" lg="12">
        <v-textarea
          v-model="message.body"
          placeholder="Escreva uma mensagem"
          filled
        >
        </v-textarea>
      </v-col>
    </v-row>
    <v-card-actions class="ml-2 pb-4">
      <v-btn
        outlined
        color="primary"
        @click="sendMessage()"
      >
        enviar
      </v-btn>
      <v-btn
        outlined
        color="green"
        @click="updateTokens()"
      >
        Atualizar tokens
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Empresa from "@/services/empresa";
import serviceNitification from "@/services/notificacao"
export default {

  data(){
    return{
      message:{
        title: "",
        body: "",
      },
      company: "",
      selectEmpresa: [],
    };
  },

  methods:{

    async getAllEmpresas(){
      this.selectEmpresa = await new Empresa().getAll();
      this.selectEmpresa.unshift({
        nome: "ENVIAR PARA TODOS",
        cnpj: "all",
      });
    },

    async updateTokens(){
      try {
        await serviceNitification.postUpdateTokens();
        this.$toast.success("Lista de tokens atualizda");
      } catch (error) {
        this.$toast.error("Falha ao atualizar lista de tokens");
      }
    },

    async sendMessage(){
      try {
        this.company != 'all' ? await serviceNitification.postCompany(this.company, this.message) : await serviceNitification.postAll(this.message);
        this.defaultData();
        this.$toast.success("Notificação enviada com sucesso");
      } catch (error) {
        this.$toast.error("Falha ao enviar notificação");
      }
    },

    defaultData(){
      this.message.title = "";
      this.message.body = "";
      this.company = "";
    }
  },

  async mounted(){
    this.getAllEmpresas();
    await serviceNitification.postUpdateTokens();
  }

}
</script>

<style>

</style>
